import React, { useContext, useEffect, useState } from 'react'
import CommonModal from '../../UiKits/Modals/common/modal'
import { Form, FormGroup, Label, Input } from 'reactstrap'
import { Btn } from '../../../AbstractElements'
import ReactQuill from 'react-quill'
import Select from 'react-select';
import UploadImageContain from '../../BonusUi/ImageUpload';
import { courseGenders, courseTypes } from '../../../Data';
import { dateCheck } from '../../../utils/date'
import { toast } from 'react-toastify';
import AdminContext from '../../../Helper/admin';
import { compareObjects, isGoogleDriveUrl } from '../../../utils/text';
import { addAdminActivity, addDoc, updateDoc, uploadImageToFirebase } from '../../../firebase/utils';
import "react-quill/dist/quill.snow.css";

const CourseModal = ({ setModal, modal, data, courses, fetchCourses, fetchGeneralPayment }) => {
  const [files, setFiles] = useState([])
  const [loading, setLoading] = useState(false)
  const [paymentText, setPaymentText] = useState("");

  const submitHandler = () => {
    const title = modal.type;
    const titleMap = {
      CREATE_COURSE: courseHandler,
      GENERAL_PAYMENT: savePaymentTextToFirebase,
      COURSE_PAYMENT: savePaymentTextToFirebase,
      EDIT_COURSE: courseHandler,
      DEPLICATE_COURSE: courseHandler,
    };
    console.log(titleMap[title])
    return titleMap[title]()
  }

  const [courseData, setCourseData] = useState({
    name: "",
    type: "beginner",
    startDate: new Date(),
    courseGenderType: "",
    endDate: "",
    isCurrent: "",
    description: "",
    courseOutline: "",
    seatsFull: "",
    admissionOpen: "",
    days: "",
  })
  const { user, location } = useContext(AdminContext)

  const currentDate = new Date();

  const savePaymentTextToFirebase = async () => {
    const modalType = modal.type
    let result = paymentText.replace(
      /^(<p><br><\/p>\s*)+|(<p><br><\/p>\s*)+$/g,
      ""
    );
    setLoading(true)
    if (modalType === "GENERAL_PAYMENT") {
      await updateDoc('generalInfo', 'dy89z5Veirs4IoclGrUI', {
        paymentDetails: result,
      })

      toast.success("Payment details edit sucessfulluy");
      setTimeout(() => {
        closeModal();
        setLoading(false)
        fetchGeneralPayment()
      }, 1000);
    } else {
      await updateDoc('courses', data.id, {
        paymentDetail: result,
      })

      toast.success(`Payment details ${courseData.paymentDetail ? "edit" : "save"} sucessfulluy`);
      setTimeout(() => {
        closeModal();
        setLoading(false)
        fetchCourses();
      }, 1000);
    }
  };

  const btnSucessText = () => {
    const title = modal.type;
    const titleMap = {
      CREATE_COURSE: 'Create',
      GENERAL_PAYMENT: 'Update',
      COURSE_PAYMENT: paymentText ? 'Update' : 'Add',
      EDIT_COURSE: 'Update',
      DEPLICATE_COURSE: 'Create',
    };
    return titleMap[title] || '';
  }

  const modalTitle = () => {
    const title = modal.type;
    const titleMap = {
      CREATE_COURSE: 'Create Course',
      GENERAL_PAYMENT: 'General Payment Details',
      COURSE_PAYMENT: 'Course Payment Details',
      EDIT_COURSE: 'Edit Course',
      DEPLICATE_COURSE: 'Create Course',
    };
    return titleMap[title] || '';
  }

  const closeModal = () => {
    setModal({ show: false, type: "" })
  }

  const courseModal = () => {
    return (<Form className='theme-form'>
      <FormGroup>
        <Label htmlFor='1' className='col-form-label'>{'Course Name'}</Label>
        <Input
          value={courseData.name}
          onChange={onChangeHandler}
          name="name"
          id='1' className='form-control' type='email'
        />
      </FormGroup>
      <FormGroup>
        <Label htmlFor='2' className='col-form-label'>{'Course Description'}</Label>
        <Input
          id='2'
          value={courseData.description}
          onChange={onChangeHandler}
          name='description'
          className='form-control' type='textarea'
        />
      </FormGroup>
      <FormGroup>
        <Label htmlFor='3' className='col-form-label'>{'Course Outline'}</Label>
        <div className='d-flex align-items-center'>
          <Input
            value={courseData.courseOutline}
            onChange={onChangeHandler}
            placeholder="Enter your Course Outline Google drive link"
            name="courseOutline"
            id='3' className='form-control' />
          <Btn attrBtn={{
            color: "primary", className: 'course-outline',
            disabled: !courseData.courseOutline.length,
            onClick: () =>
              window.open(courseData.courseOutline, "_blank")
          }}>View Course Outline</Btn>
        </div>
      </FormGroup>
      <FormGroup>
        <Label htmlFor='3' className='col-form-label'>{'Course Type'}</Label>
        <Select
          value={courseTypes.find((co) => co.value === courseData.type)}
          onChange={(e) => selectChangeHandler('type', e?.value)}
          options={courseTypes}
          className="js-example-basic-single col-sm-12" />
      </FormGroup>
      <FormGroup>
        <Label htmlFor='2' className='col-form-label'>{'Course Days'}</Label>
        <Input id='2' value={courseData.days}
          onChange={onChangeHandler} name="days"
          className='form-control' type='text' placeholder='sat & sun & mon' />
      </FormGroup>
      <div className='d-flex align-items-center'>
        <FormGroup className='m-0 w-100'>
          <Label htmlFor='2' className='col-form-label'>{'Start Date'}</Label>
          <Input id='2' value={courseData.startDate}
            onChange={onChangeHandler}
            min={currentDate}
            type="datetime-local"
            name="startDate" className='form-control' />
        </FormGroup>
        <FormGroup className='m-0 m-l-10 w-100'>
          <Label htmlFor='2' className='col-form-label'>{'End Date'}</Label>
          <Input id='2' className='form-control' type="datetime-local"
            value={courseData.endDate}
            onChange={onChangeHandler}
            name="endDate" />
        </FormGroup>
      </div>
      <FormGroup>
        <Label htmlFor='1' className='col-form-label'>{'Whatsapp Group Link'}</Label>
        <Input id='1' className='form-control' type='text' value={courseData.whatsappLink}
          onChange={onChangeHandler}
          placeholder="Enter Whatsapp link here"
          name="whatsappLink" />
      </FormGroup>
      <FormGroup>
        <Label htmlFor='3' className='col-form-label'>{'Select Gender'}</Label>
        <Select
          options={courseGenders}
          value={courseGenders.find((co) => co.value === courseData.courseGenderType)}
          onChange={(e) => selectChangeHandler('courseGenderType', e?.value)}
          className="js-example-basic-single col-sm-12" />
      </FormGroup>
      <div className='fee-refund'>
        <UploadImageContain
          files={files}
          setFiles={setFiles}
          heeading='Course Icon'
        />
      </div>
      <FormGroup>
        <Label className="d-block" htmlFor="chk-ani1">
          <Input className="checkbox_animated" id="chk-ani1" value={courseData.isCurrent}
            onChange={({ target }) =>
              setCourseData({
                ...courseData,
                isCurrent: target.checked,
              })
            }
            defaultChecked={courseData.isCurrent === true}
            type="checkbox" />Current Course
        </Label>
      </FormGroup>
      <FormGroup>
        <Label className="d-block" htmlFor="chk-ani2">
          <Input className="checkbox_animated" value={courseData.seatsFull}
            onChange={({ target }) =>
              setCourseData({
                ...courseData,
                seatsFull: target.checked,
              })
            } id="chk-ani2" type="checkbox" defaultChecked={courseData.seatsFull === true}
          />Seats Full
        </Label>
      </FormGroup>
      <FormGroup>
        <Label className="d-block" htmlFor="chk-ani3">
          <Input value={courseData.admissionOpen}
            defaultChecked={courseData.admissionOpen === true}

            onChange={({ target }) =>
              setCourseData({
                ...courseData,
                admissionOpen: target.checked,
              })
            } className="checkbox_animated" id="chk-ani3" type="checkbox" />Admission Open
        </Label>
      </FormGroup>
    </Form>)
  }

  const paymentDetails = () => {
    return (<div>
      <ReactQuill theme="snow"
        value={paymentText}
        onChange={setPaymentText}
        modules={{
          toolbar: [
            ["bold", "italic", "underline", "strike"], // text formatting options
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // header options
            ["blockquote", "code-block"], // blockquote and code block
            [{ list: "ordered" }, { list: "bullet" }], // ordered and unordered lists
            [{ script: "sub" }, { script: "super" }], // subscript and superscript
            [{ indent: "-1" }, { indent: "+1" }], // decrease and increase indent
            [{ direction: "rtl" }], // right-to-left text direction
            [{ color: [] }, { background: [] }], // text color and background color options
            ["link", "image", "video"], // link, image, and video options
            ["clean"], // remove formatting option
          ],
        }} />
    </div>)
  }

  const renderContent = (type) => {
    switch (type) {
      case "EDIT_COURSE":
        return courseModal()
      case "DEPLICATE_COURSE":
        return courseModal()
      case "CREATE_COURSE":
        return courseModal()
      case 'GENERAL_PAYMENT':
        return paymentDetails()
      case 'COURSE_PAYMENT':
        return paymentDetails()
      default:
        return
    }
  }

  const courseHandler = async () => {

    let iconUrl;
    const {
      name,
      type,
      startDate,
      endDate,
      isCurrent,
      id,
      days,
      seatsFull,
      courseGenderType,
      description,
      courseOutline,
      admissionOpen,
      whatsappLink,
    } = courseData;
    const isEmpty =
      !name.trim().length ||
      !type.length ||
      !description.length ||
      !files.length ||
      !courseOutline.length ||
      !startDate.length ||
      !endDate.length;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (isEmpty) {
      toast.error("Please fill up all details");
      return;
    }
    const courseAlreadyExist = courses.find(
      (course) => course.name === name && course.type === type
    );
    const extraCourses = courses.filter((course) => course.id !== id);
    if (modal.type !== "EDIT_COURSE" && courseAlreadyExist) {
      toast.error("Course Already Exist");
      return;
    }
    const isEditModeCourseExist = extraCourses.find(
      (course) => course.name === name && course.type === type
    );
    if (modal.type === "EDIT_COURSE" && isEditModeCourseExist) {
      toast.error("Course Already Exist");
      return;
    }

    if (whatsappLink) {
      const r = /^(ftp|http|https):\/\/[^ "]+$/;
      if (!r.test(whatsappLink)) {
        toast.error("Whatsapp link is invalid");
        return;
      }
    }

    const selectedArray =
      modal.type === "EDIT_COURSE" ? extraCourses : courses;

    setLoading(true);
    const courseIcon = files[0].preview.url
    console.log('courseIcon', courseIcon)
    if (courseIcon.includes('blob')) {
      console.log(files[0])
      const { preview, ...img } = files[0]
      console.log(img)
      iconUrl = await uploadImageToFirebase(files[0], 'courseIcons');
      courseData.icon = iconUrl
    }
    const activityOptions = {
      adminId: user.email,
      type: 'create_course',
      createdAt: new Date(),
      activity: `${user.email} created course ${courseData.name} ${courseData.type}`,
    };
    if (!isGoogleDriveUrl(courseOutline)) {
      return toast.error("Please provide a valid Google Drive URL.");
    }
    if (modal.type === "EDIT_COURSE") {
      const changes = compareObjects(data, courseData);
      if (Object.keys(changes.new).length) {
        activityOptions.oldData = changes.previous;
        activityOptions.newData = changes.new;
      }
      activityOptions.type = 'edit_course';
      activityOptions.activity = `${user.email} modified course ${courseData.name} ${courseData.type}`;

      await addAdminActivity(activityOptions, location);
      await updateDoc('courses', id, {
        name,
        type,
        courseGenderType,
        startDate,
        endDate,
        isCurrent,
        icon: iconUrl ?? courseIcon,
        description,
        courseOutline,
        seatsFull,
        admissionOpen,
        days,
        whatsappLink,
      });
      toast.success("Course updated successfully");
    } else {
      activityOptions.courseName = name;
      activityOptions.courseType = type;
      await addAdminActivity(activityOptions, location);
      await addDoc('courses', {
        name,
        type,
        startDate,
        courseGenderType,
        description,
        courseOutline,
        icon: iconUrl,
        endDate,
        isCurrent,
        seatsFull,
        admissionOpen,
        days,
        whatsappLink,
      });
      toast.success("Course added successfully");
    }
    setTimeout(() => {
      setLoading(false);
      closeModal();
      fetchCourses();
    }, 1000);
  }

  const onChangeHandler = ({ target }) => {
    setCourseData({ ...courseData, [target.name]: target.value });
  };

  const selectChangeHandler = (name, value) => {
    setCourseData({ ...courseData, [name]: value });
  }

  useEffect(() => {
    const title = modal.type;

    if (title === 'EDIT_COURSE' || title === 'DEPLICATE_COURSE') {
      const value = (data.courseGenderType = data.courseGenderType
        ? data.courseGenderType
        : "both");
      setFiles([{
        preview: {
          url: data?.icon
        }
      }])
      setCourseData(data)
    } else if (title === 'GENERAL_PAYMENT' || title === 'COURSE_PAYMENT') {
      setPaymentText(data.paymentDetail ? data.paymentDetail : data)
    }
  }, [])

  return (
    <div>
      <CommonModal
        isOpen={true}
        toggler={() => closeModal()}
        showCloseBtn={false}
        successText={btnSucessText()}
        title={modalTitle()}
        success={() => submitHandler()}
        disabled={loading}
        loading={loading}
        bodyClass='full-screen-modal'
        size="lg"
      >
        <div>
          {renderContent(modal.type)}
        </div>
      </CommonModal>
    </div>
  )
}

export default CourseModal